
import type { PropType } from 'vue'
import type { RelatedTagConfig } from '../../models/components/related-tag-config'

import type { Action } from '../shared/epb-pill'

import { computed, defineComponent, ref } from 'vue'
import { ColorEnum, RelatedTagPositionEnum } from '../../enums'

import { ValidityStateTypeEnum } from '../../models/components/related-tag-config'
import { EpbPill } from '../shared/epb-pill'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'RelatedTag',
  components: {
    EpbPill,
    EpbText,
  },
  props: {
    tagConfig: {
      type: Object as PropType<RelatedTagConfig>,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    editable: Boolean,
    readOnly: Boolean,
    messages: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const baseClass = 'epb-related-tag'
    const tagInputEl = ref(null)

    const removed = computed<boolean>(() => {
      return props.tagConfig.rule?.type === 'REMOVE'
    })

    const tagQueryElements = computed<Array<string>>(() => {
      const tagQueryElements = ['tag-input', 'query-label']
      if (props.tagConfig.tagPosition === RelatedTagPositionEnum.AFTER_QUERY) {
        tagQueryElements.reverse()
      }
      return tagQueryElements
    })

    const tagIcon = computed((): string => {
      return !!props.tagConfig.rule && !removed.value ? 'usercirclesolid' : ''
    })

    const tagActions = computed((): Array<Action> => {
      const isRemoved: Action[] = removed.value
        ? [{ icon: 'replay', id: 'replay' }]
        : [{ icon: 'close', id: 'close' }]
      return !props.readOnly && !props.editable ? isRemoved : []
    })

    function focus(): void {
      tagInputEl.value[0].focus()
    }

    function onClick(): void {
      if (props.editable) {
        focus()
      } else if (!removed.value) {
        emit('click')
      }
    }

    function onEnter(tag: string): void {
      if (props.tagConfig.validityState.type !== ValidityStateTypeEnum.ERROR) {
        emit('edit', tag)
      }
    }

    return {
      baseClass,
      tagInputEl,
      removed,
      tagQueryElements,
      tagIcon,
      tagActions,
      ValidityStateTypeEnum,
      ColorEnum,
      focus,
      onClick,
      onEnter,
    }
  },
})
